import AjaxResolver from 'owd/module/ajax';

export default class LoadMoreResolver extends AjaxResolver {
	shouldPushState() {
		return false;
	}

	pageIn() {
		const deferred = $.Deferred();

		deferred.resolve();

		return deferred.promise();
	}

	pageOut() {
		const deferred = $.Deferred();

		// $('[data-load-more]').css('display', 'none');
		$('[data-load-more]').addClass('not-active'); 

		deferred.resolve();

		return deferred.promise();
	}

	updateContent($loadedContent) {
		const deferred = $.Deferred();

		const $currentContainer = $('.posts');
		const $newContainer = $loadedContent.find('.posts');
		const $newContent = $newContainer.children();

		$currentContainer.append($newContent);

		// if ($newContainer.data('next-posts') === undefined || $newContainer.data('next-posts') === '') {
		// 	$('[data-load-more]').hide();
        //     $('.blog-navigation a').hide();
		// } else {
		// 	$('[data-load-more]').attr('href', $newContainer.data('next-posts'));
		// 	$('[data-load-more]').css('opacity', '1');
        //     $('.blog-navigation a').show();
		// }

		deferred.resolve($('<div>'), $newContent);

		return deferred.promise();
	}
}
